import { render, staticRenderFns } from "./AllIdentityVerifyList.vue?vue&type=template&id=1ee4a99c&scoped=true&"
import script from "./AllIdentityVerifyList.vue?vue&type=script&lang=js&"
export * from "./AllIdentityVerifyList.vue?vue&type=script&lang=js&"
import style0 from "./AllIdentityVerifyList.vue?vue&type=style&index=0&id=1ee4a99c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee4a99c",
  null
  
)

export default component.exports